<!-- Breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Laboratorio</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Resultados</span>
    </div>
  </div>
</div>

<!-- Filtros -->
<div class="row row-sm mb-3">
  <div class="col-12">
    <div class="card">
      <h6 class="card-title text-uppercase text-white p-2 mb-0" style="background-color:#0a2463;">
        Filtrar
      </h6>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-12 col-md-3">
            <label class="form-label fw-semibold">Desde</label>
            <input type="date" class="form-control" [(ngModel)]="fechaInicio">
          </div>
          <div class="col-12 col-md-3">
            <label class="form-label fw-semibold">Hasta</label>
            <input type="date" class="form-control" [(ngModel)]="fechaFin">
          </div>
          <div class="col-12 col-md-3">
            <label class="form-label fw-semibold">Estado</label>
            <select class="form-select" [(ngModel)]="estado">
              <option value="facturadas">Pendientes</option>
              <option value="con-resultados">Atendidas</option>
            </select>
          </div>
          <div class="col-12 col-md-3">
            <button class="btn btn-primary w-100" (click)="aplicarFiltros()">
              <i class="fe fe-filter me-1"></i> Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tabla -->
<div class="row row-sm">
  <div class="col-12">
    <div class="card">
      <div class="card-body">

        @if (cargandoSucursales) {
          <div class="text-center py-4">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 text-muted">Cargando sucursales...</p>
          </div>
        }

        @if (!cargandoSucursales) {
          <!-- Tabs de sucursales -->
          <ul class="nav nav-pills sucursales-tabs">
            @for (s of sucursales; track s.COD_SURC) {
              <li class="nav-item">
                <a class="nav-link"
                   [class.active]="sucursalActiva === s.COD_SURC"
                   href="javascript:;"
                   (click)="cambiarSucursal(s.COD_SURC)">
                  {{ s.DIR_SURC }}
                  @if (s.pendientes !== undefined && s.pendientes > 0) {
                    <span class="badge rounded-pill ms-1"
                          [ngClass]="sucursalActiva === s.COD_SURC ? 'bg-white text-dark' : 'bg-dark'">
                      {{ s.pendientes }}
                    </span>
                  }
                </a>
              </li>
            }
            @for (t of TABS_ESPECIALES; track t.COD_SURC) {
              <li class="nav-item">
                <a class="nav-link"
                   [class.active]="sucursalActiva === t.COD_SURC"
                   href="javascript:;"
                   (click)="cambiarSucursal(t.COD_SURC)">
                  {{ t.DIR_SURC }}
                </a>
              </li>
            }
          </ul>

          <!-- Spinner de carga de datos -->
          @if (spinnerBoolean) {
            <div class="text-center py-3">
              <div class="spinner-grow text-primary" role="status"></div>
              <p class="mt-1 text-muted">Procesando, espere...</p>
            </div>
          }

          <!-- DataTable -->
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                   class="table table-bordered table-striped table-hover dt-ext mobile-friendly-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>N° FAC.</th>
                  <th>Nº Orden</th>
                  <th>Fecha</th>
                  <th>Hora</th>
                  <th>Nombre</th>
                  <th>Edad</th>
                  <th>Comentario</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                @for (dt of ordenes; track dt.COD_ORD; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ dt.numeroFacturaOrden || '-' }}</td>
                    <td>
                      @if (dt.LINKLAB_ORD) {
                        <a [href]="dt.LINKLAB_ORD" target="_blank">{{ dt.NUM_ORD }}</a>
                      } @else {
                        {{ dt.NUM_ORD }}
                      }
                      @if (orionError(dt.RESP_ORION); as msg) {
                        <div class="text-danger fw-semibold tx-11 mt-1">ERROR ORION: {{ msg }}</div>
                      }
                    </td>
                    <td>{{ dt.FECHA }}</td>
                    <td>{{ dt.HORA }}</td>
                    <td>{{ dt.NOM_CLI }}</td>
                    <td>{{ dt.EDAD_CLI }}</td>
                    <td>{{ dt.OBS_ORD }}</td>
                    <td>

                      @if (isMobileView) {
                        <div class="d-flex flex-column gap-2 mt-1">
                          <button type="button" class="btn btn-outline-danger btn-sm mobile-action-btn"
                                  (click)="verOrden(dt)">
                            <i class="zmdi zmdi-collection-pdf me-1"></i> Ver orden
                          </button>
                          @if (mostrarBtnResultados) {
                            <button type="button" class="btn btn-outline-success btn-sm mobile-action-btn"
                                    (click)="generarOrdenOrion(dt)">
                              <i class="fa fa-flask me-1"></i> Ingresar a Orion
                            </button>
                          }
                          @if (mostrarBtnVerResultados) {
                            <button type="button" class="btn btn-outline-danger btn-sm mobile-action-btn">
                              <i class="fa fa-file-pdf-o me-1"></i> Ver resultados
                            </button>
                          }
                          <button type="button" class="btn btn-outline-info btn-sm mobile-action-btn"
                                  (click)="abrirComentario(dt)">
                            <i class="fa fa-comment me-1"></i> Comentario
                          </button>
                          <button type="button" class="btn btn-outline-primary btn-sm mobile-action-btn"
                                  (click)="imprimirTicket(dt)">
                            <i class="fa fa-print me-1"></i> Imprimir ticket
                          </button>
                        </div>
                      }

                      @if (!isMobileView) {
                        <div ngbDropdown container="body">
                          <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                            <i class="fe fe-settings"></i>
                          </button>
                          <div class="tx-13" ngbDropdownMenu>
                            <a ngbDropdownItem href="javascript:;" (click)="verOrden(dt)">
                              <i class="zmdi zmdi-collection-pdf text-danger"></i>&nbsp; Ver orden
                            </a>
                            @if (mostrarBtnResultados) {
                              <a ngbDropdownItem href="javascript:;" (click)="generarOrdenOrion(dt)">
                                <i class="fa fa-flask text-success"></i>&nbsp; Ingresar orden a Orion
                              </a>
                            }
                            @if (mostrarBtnVerResultados) {
                              <a ngbDropdownItem href="javascript:;">
                                <i class="fa fa-file-pdf-o text-danger"></i>&nbsp; Ver resultados
                              </a>
                            }
                            <a ngbDropdownItem href="javascript:;" (click)="abrirComentario(dt)">
                              <i class="fa fa-comment text-info"></i>&nbsp; Comentario
                            </a>
                            <a ngbDropdownItem href="javascript:;" (click)="imprimirTicket(dt)">
                              <i class="fa fa-print text-primary"></i>&nbsp; Imprimir ticket
                            </a>
                          </div>
                        </div>
                      }

                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<!-- Modal Comentario -->
<ng-template #mdlComentario>
  <div class="modal-header">
    <h6 class="modal-title">Comentario — Orden {{ numOrdenComentario }}</h6>
  </div>
  <div class="modal-body">
    <textarea class="form-control" rows="4" [(ngModel)]="comentario"
              placeholder="Ingrese el comentario..."></textarea>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalComentarioRef?.close()">Salir</button>
    <button type="button" class="btn btn-primary" (click)="guardarComentario()">Guardar</button>
  </div>
</ng-template>
